import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteNominationContact: (
  fetchContext: FetchContext,
  contactId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, contactId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/contacts/${contactId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete nomination contact'));
